/* eslint-disable no-console */
import { thirdPartyWithLayoutService } from '@bedrock/fido-sdk';
import { ERROR_LEVELS } from './error.constants';
import { showPopupAction } from '../popup/popup.actions';
import { FATAL_ERROR_POPUP_ID } from '../../modules/popups/popups.constants';
import { setCloseReason } from '../lifecycle/lifecycle.utils';
import { navigateToLandingPage } from '../../modules/routes/routes.utils';
import { logout } from '../pairing/unpair.actions';

export const ERROR = 'error';
export const RETRYABLE_ERROR = 'retryable_error';
export const RETRY = 'retry';

// TODO: error - navigate to error page

/**
 * This redux thunk action has to be called to signal an unexpected error while the user is using the app. Multiple
 * levels, types and custom message are possible to finally inform the user, from blocking crash to silent error cases.
 *
 * @summary Handle application errors.
 * @function
 * @name errorAction
 * @param {ErrorLevels} level
 * @param {ErrorTypes} errorType
 * @param {string} message
 */
export const errorAction = (level, errorType, message) => dispatch => {
  if (!level) {
    console.warn('[Error] Missing error level');
  }

  if (!errorType) {
    console.warn('[Error] Missing error type');
  }

  if (!message) {
    console.warn('[Error] Missing error message');
  }

  console.error(`[Error] ${errorType}: ${message}`);

  if (level === ERROR_LEVELS.FATAL) {
    if (typeof message === 'string' && message.includes('tokenService') && message.includes('498')) {
      console.log('[Error] Authorization issue detected, logging out');

      dispatch(logout()).finally(() => navigateToLandingPage());
    } else {
      setCloseReason('error');
      dispatch(showPopupAction(FATAL_ERROR_POPUP_ID, {}));
    }
  }

  thirdPartyWithLayoutService.sendErrorEvent(new Error(`${errorType} - ${message}`));
};
